export enum ActionTypes {
  TAG = "TAG",
  CHIP = "CHIP",
  MARKETING = "MARKETING",
  USER = "USER",
  CONTRACT_FLOW = "CONTRACT_FLOW",
  TERM_FLOW = "TERM_FLOW"
}
